module.exports = __webpack_public_path__ + "img/walk.461a4f2a.svg";